module.exports = __webpack_public_path__ + "static/img/200073.59f32baa.png";